import { AlertModalLayout, Button, Stack, Typography } from '@ui-components/neo.tax';
import { ReactElement } from 'react';

import { ModalStyled } from './rd-project-document-upload-form.styles';

export type GenerateNarrativeModalProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * This modal confirms the generation of the project narrative.
 */

// TODO: Add "Project Description" to the fields to be overridden in the follow up ticket: https://linear.app/neo-tax/issue/NEO-5126/support-generating-project-description-ticketless
export const GenerateNarrativeModal = ({
  isOpen = false,
  onCancel,
  onConfirm,
}: GenerateNarrativeModalProps): ReactElement => (
  <ModalStyled isOpen={isOpen} setIsOpen={onCancel}>
    <AlertModalLayout
      title="Are you ready to update the project narrative?"
      copy=""
      trailingContent={
        <>
          <Button size="base" variant="white" rounded="regular" onClick={onCancel}>
            Cancel
          </Button>
          <Button size="base" variant="primary" rounded="regular" onClick={onConfirm}>
            Yes
          </Button>
        </>
      }
    >
      <Stack direction="column" space={2}>
        <Typography as="p" fontSize="sm">
          Make sure you have uploaded all project documents first. Neo.Tax will use these documents to generate new
          values for:
        </Typography>
        <ul>
          <li>
            <Typography as="span" fontSize="sm">
              -{' '}
              <Typography as="span" fontSize="sm" fontWeight="medium">
                Project Description
              </Typography>
            </Typography>
          </li>
          <li>
            <Typography as="span" fontSize="sm">
              -{' '}
              <Typography as="span" fontSize="sm" fontWeight="medium">
                Project Purpose
              </Typography>
            </Typography>
          </li>
          <li>
            <Typography as="span" fontSize="sm">
              -{' '}
              <Typography as="span" fontSize="sm" fontWeight="medium">
                Technical Challenges
              </Typography>
            </Typography>
          </li>
          <li>
            <Typography as="span" fontSize="sm">
              -{' '}
              <Typography as="span" fontSize="sm" fontWeight="medium">
                Process of Experimentation
              </Typography>
            </Typography>
          </li>
        </ul>
        <Typography as="p" fontSize="sm">
          Neo.Tax will also evaluate the project&apos;s R&D credit eligibility and show the results in the AI Guidance
          column.
        </Typography>
        <Typography as="p" fontSize="sm">
          Click Yes to continue.
        </Typography>
      </Stack>
    </AlertModalLayout>
  </ModalStyled>
);
